export class IconsContainer {
    public icons = new Map();

    public add(name: string, path: string) {
        this.icons.set(name, path);
    }
}
